import React from 'react'
import { observer } from 'mobx-react'
import ResultModal from './Modals/ResultModal'
import PatientInfo from './Components/PatientInfo'
import PatientPageStore from './Store/PatientPageStore'
import PatientYearlyResult from './Components/PatientYearlyResult/PatientYearlyResult'
import PatientResult from './Components/PatientsResult'
import Page from '../../../components/Pages/Page'
import ChangePasswordModal from './Modals/ChangePasswordModal'
import ChangeUserInfoModal from './Modals/ChangeUserInfoModal'
import ResetPasswordModal from './Modals/ResetPasswordModal'

import SaleModal from './Modals/SaleModal'

const PatientPageTemplate = observer(
  (props) => {
    return (
      <>
        {PatientPageStore.discount && <SaleModal visibility={PatientPageStore?.discount} />}
        {PatientPageStore.resultModal.show ? <ResultModal /> : ''}
        {PatientPageStore.resetPasswordModal.show ? <ResetPasswordModal /> : ''}
        {PatientPageStore.patientInfoChangeModal.show ?
          <ChangeUserInfoModal userData={PatientPageStore.patientInfo} /> : ''}
        {PatientPageStore.passwordChangeModal.show ? <ChangePasswordModal /> : ''}
                <Page name={'patient-page'} mobile={true} animation={'fade-in-fwd'}>
                    <div className='patient-bar'>
                        <PatientInfo/>
					  {/*  <PatientYearlyResult/> */}
                      {/*<GetPhoto onClick={props.getImage}/>*/}
                    </div>
                    <PatientResult
                        title="Процедуры и результаты"
                        haveToShow={['resultDate', 'daysLeft', 'available']}/>
                </Page>
            </>
        )
    })
export default PatientPageTemplate